import React, { useState, useEffect, useRef  } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from './DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png';
import FilePreviewer from "../common/file_displayer";

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const [searchText, setSearchText] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
const [isPopupOpen, setIsPopupOpen] = useState(false);
const [pdfUrl, setPdfUrl] = useState("");
const [popupData, setPopupData] = useState(null);
const [popupFiles, setPopupFiles] = useState([]);
const [currentFileIndex, setCurrentFileIndex] = useState(0);

const gridRef = useRef(null);
  const handleTabSelect = (index) => {
    console.log(index);
    setTabIndex(index);
  };

const openPopup = (row) => {
  setPdfUrl("/sample.pdf"); // replace later with row-based PDF
  setPopupData({
    vendorName: row.vendor_name,
    invoiceNo: row.vendor_code,
    amount: row.amount || "N/A",
    date: row.created_on || "N/A",
  });

  BrsTypeList(row);   // pass ROW DATA
  setIsPopupOpen(true);
};


const BrsTypeList = (row) => {
  if (!row || !row.vendor_code) return;

  const payload = {
    query: `
      SELECT id, vendor_file
      FROM payments.vendor_files
      WHERE vendor_code = "${row.vendor_code}"
        AND entity_id = '${userCredentials.selectedentity}';
    `
  };

  const creds = Fetchexecutequery();

  axios
    .post(creds[1], payload, creds[0])
    .then((response) => {
      const data = response.data || [];

      // Normalize files
      const files = data.map((item) => ({
        id: item.id,
        path: item.vendor_file,
      }));

      console.log("Files for popup:", files);

      /*
        files = [
          { id: 1, path: "/files/vendor/doc1.pdf" },
          { id: 2, path: "/files/vendor/doc2.pdf" }
        ]
      */

      // OPTIONAL: set state for popup
      setPopupFiles(files);
      setCurrentFileIndex(0);
      setPdfUrl(files.length > 0 ? files[0].path : "");

    })
    .catch((error) => {
      console.error("Error fetching file list", error);
    });
};

const deleteFile = (fileId) => {
  if (!window.confirm("Are you sure you want to delete this file?")) return;

  console.log("Deleting file with id:", fileId);

  const updatedFiles = popupFiles.filter((f) => f.id !== fileId);
  setPopupFiles(updatedFiles);

  if (updatedFiles.length === 0) {
    setPdfUrl("");
    setCurrentFileIndex(0);
    return;
  }

  const newIndex =
    currentFileIndex >= updatedFiles.length
      ? updatedFiles.length - 1
      : currentFileIndex;

  setCurrentFileIndex(newIndex);
  setPdfUrl(updatedFiles[newIndex].path);
};


const handlePrev = () => {
  if (currentFileIndex > 0) {
    const newIndex = currentFileIndex - 1;
    setCurrentFileIndex(newIndex);
    setPdfUrl(popupFiles[newIndex].path);
  }
};

const handleNext = () => {
  if (currentFileIndex < popupFiles.length - 1) {
    const newIndex = currentFileIndex + 1;
    setCurrentFileIndex(newIndex);
    setPdfUrl(popupFiles[newIndex].path);
  }
};



const closePopup = () => {
  setIsPopupOpen(false);
};


useEffect(() => {
  if (tabIndex === 0) {
    fetchFieldInfo1();
    fetchFieldInfo2();
  }

  if (tabIndex === 1) {
    fetchFieldInfo_1();
    fetchFieldInfo3();
  }

  if (tabIndex === 2) {
    fetchFieldInfo1();
    fetchFieldInfo4();
  }
}, [tabIndex]);


  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo_1 = async () => {
    const payload = { headerconfig_id: 20,"filterconditions":[]  };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,

        }));
        columns.push({
          headerName: "View",
          field: "View",
          cellRendererFramework: (params) => (
            <Icon
              name="eye"
              style={{ cursor: 'pointer' }}
              onClick={() => openPopup(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
  };


  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 20,"filterconditions":[]  };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], // URL
        payload,                  // Payload
        FileUploadCredentials[0]   // Headers or Credentials
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,

        }));
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100, // Set width for the edit column
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
  };

  const handleEditClick = (row) => {
    console.log("Editing row:", row);
    setFormData(row); // Populate formData with row data for editing
    setEditMode(true); // Set edit mode to true
  };

  const fetchFieldInfo2 = async () => {
    setLoading(true);
    const payload = { query: `SELECT id,vendor_code,vendor_name,location,address,email_id,gst_number,pan_number FROM po_process.vendor_master where entity_id = '${userCredentials.selectedentity}';` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
    setLoading(false);
  };

const downloadCsv = () => {
  if (!gridRef.current) return;

  gridRef.current.api.exportDataAsCsv({
    fileName: "vendor_master.csv",
  });
};



  const fetchFieldInfo3 = async () => {
    setLoading(true);
    const payload = { query: `SELECT id,vendor_code,vendor_name,location,address,email_id,gst_number,pan_number FROM po_process.vendor_master
 where entity_id = '${userCredentials.selectedentity}' and
 vendor_code in (SELECT distinct vendor_code FROM payments.vendor_files where entity_id = '${userCredentials.selectedentity}');` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
    setLoading(false);
  };

  const fetchFieldInfo4 = async () => {
    setLoading(true);
    const payload = { query: `SELECT id,vendor_code,vendor_name,location,address,email_id,gst_number,pan_number FROM po_process.vendor_master
 where entity_id = '${userCredentials.selectedentity}' and
 vendor_code not in (SELECT distinct vendor_code FROM payments.vendor_files where entity_id = '${userCredentials.selectedentity}')` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);

      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
    setLoading(false);
  };


  const handleCreate = () => {
    const formattedDate = getFormattedDate();
    console.log('formData',formData,formData.id)
    const updatedFormData = { ...formData,created_on: formattedDate,last_updated_on: formattedDate,last_updated_by: userCredentials.user_name,entity_id: userCredentials.selectedentity};


    const payload = {
      database: 'po_process',
      table: 'vendor_master',
      formData: updatedFormData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Create response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {

    const formattedDate = getFormattedDate();
    console.log('formData',formData,formData.id)
    const updatedFormData = { ...formData,last_updated_on: formattedDate,last_updated_by: userCredentials.user_name,entity_id: userCredentials.selectedentity};

    // Remove primary_id from the copied formData
    delete updatedFormData.id;
    const payload = {
      schema_name: 'po_process',
      table: 'vendor_master',
      set_column : updatedFormData,
      'where' : [{"id":formData.id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };


return (
<>
<LoaderComponent loaderOpen={loading} />

<div>
      <h2
        className="pt-1 pb-1 text-center"
        style={{ color: "#4969ab", fontSize: "18px" }}
      >
        VENDOR MASTER
      </h2>

  <Tabs selectedIndex={tabIndex} onSelect={handleTabSelect}>
    <TabList>
      <Tab>Vendor Master</Tab>
      <Tab>Vendor With Agreements</Tab>
      <Tab>Vendor Without Agreements</Tab>
    </TabList>

    {/* TAB 1 */}
    <TabPanel>

      {error && <div style={{ color: "red" }}>{error}</div>}

      <DynamicForm
        fields={fields}
        formData={formData}
        onInputChange={handleInputChange}
        onSubmit={handleSubmit}
      />

      <div
        className="submit-row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "3px",
          paddingRight: "10px",
        }}
      >
        <input
          className="search-input"
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={onFilterTextChange}
          style={{
            width: "30%",
            backgroundColor: "white",
            marginRight: "8px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ced4da",
          }}
        />

        <button
          type="submit"
          className="submit-btn"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <div
          className="ag-theme-alpine"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            borderRadius: "10px",
            width: `${columnDefs.length * 200}px`,
            maxWidth: "100%",
            maxHeight: "300px",
            height: "400px",
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            quickFilterText={searchText}
            pagination
            paginationPageSize={10}
            enableCellTextSelection={true}
            suppressCopyRows={true} 

          />
        </div>
      </div>
    </TabPanel>

    {/* TAB 2 */}
    <TabPanel>
     <div style={{ padding: "10px", color: "#777" }}>
  
  {/* Search Bar Row */}
<div
  style={{
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "10px",
    marginTop: 0,
    paddingTop: 0,
  }}
>
  <input
    className="search-input"
    type="text"
    placeholder="Search..."
    value={searchText}
    onChange={onFilterTextChange}
    style={{
      width: "30%",
      backgroundColor: "white",
      borderRadius: "4px",
      border: "1px solid #ced4da",
      margin: 0,
      padding: "8px",
    }}
  />
    <img
      src={excelIcon}
      alt="Export to Excel"
      title="Download Excel"
      onClick={downloadCsv}
      style={{
        width: "28px",
        height: "28px",
        cursor: "pointer",
      }}
    />

</div>

  {/* Grid */}
<div
  className="ag-theme-alpine"
  style={{
    overflowX: "auto",
    overflowY: "auto",
    borderRadius: "10px",
    width: `${columnDefs.length * 250}px`,
    maxWidth: "100%",
    height: "690px",
  }}
>
  <AgGridReact
    ref={gridRef}
    columnDefs={columnDefs}
    rowData={rowData}
    quickFilterText={searchText}
    pagination
    paginationPageSize={15}
    enableCellTextSelection
    suppressCopyRows
  />
</div>

</div>

    </TabPanel>

    {/* TAB 3 */}
    <TabPanel>
      <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
         <div
          className="ag-theme-alpine"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            borderRadius: "10px",
            width: `${columnDefs.length * 200}px`,
            maxWidth: "100%",
            maxHeight: "300px",
            height: "400px",
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            quickFilterText={searchText}
            pagination
            paginationPageSize={10}
            enableCellTextSelection={true}
            suppressCopyRows={true}
          />
        </div>
            </div>
    </TabPanel>
  </Tabs>

{isPopupOpen && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.4)",
      zIndex: 1000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      style={{
        width: "80%",
        height: "90%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        padding: "10px",overflow: "hidden", 
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #ddd",
          paddingBottom: "8px",
        }}
      >
        <h3>Document Details</h3>
        <button
  onClick={closePopup}
  style={{
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
  }}
>
  <Icon name="times circle" color="red" />
</button>

      </div>

      {/* Content */}
      <div style={{ display: "flex", height: "100%",minHeight: 0, marginTop: "10px" }}>
        
        {/* LEFT: Details */}
        <div style={{ width: "30%", padding: "10px" }}>
          <p><b>Vendor:</b> {popupData?.vendorName}</p>
          <p><b>Invoice No:</b> {popupData?.invoiceNo}</p>
          <p><b>Amount:</b> {popupData?.amount}</p>
          <p><b>Date:</b> {popupData?.date}</p>
        </div>

        {/* RIGHT: PDF */}
{/* RIGHT: PDF + Controls */}
<div style={{ width: "70%", height: "100%", display: "flex", flexDirection: "column" }}>
  
  {/* Controls */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "6px",
    }}
  >
    <div>
<button onClick={handlePrev} disabled={currentFileIndex === 0}>
  <Icon name="arrow left" />
  Previous
</button>

<button
  onClick={handleNext}
  disabled={currentFileIndex === popupFiles.length - 1}
  style={{ marginLeft: "8px" }}
>
  Next
  <Icon name="arrow right" />
</button>
    </div>

    <div>
      <span style={{ marginRight: "10px" }}>
        File {currentFileIndex + 1} of {popupFiles.length}
      </span>

      <button
        style={{ color: "red" }}
        onClick={() => deleteFile(popupFiles[currentFileIndex].id)}
      >
        Delete
      </button>
    </div>
  </div>

    <FilePreviewer
      fileType="pdf"
      fileUrl ={`http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/${pdfUrl.split('/').pop()}`}
      style={{ height: "100%", width: "100%" }} // make the PDF fit
    />

</div>

      </div>
    </div>
  </div>
)}

</div>
</>
);
}

export default DepartmentCreation;
